import { render, staticRenderFns } from "./ListagemAprovacoes.vue?vue&type=template&id=ccd40bc4&"
import script from "./ListagemAprovacoes.vue?vue&type=script&lang=js&"
export * from "./ListagemAprovacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports